export default __webpack_public_path__ + "static/media/ourclient7.8dc49ad6.png";